import React, { ReactNode, FC } from 'react'
import { ConfigProvider } from 'antd'

interface ThemeProviderProps {
  children: ReactNode
}
export const ThemeProvider: FC<ThemeProviderProps> = ({ children }) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorIcon: '#13304a',
          colorPrimary: '#024e69 ', // Light Teal
          colorPrimaryHover: '#333333', // Dark Teal
          colorBgBase: '#ffffff', // White
          colorBgContainer: '#f4f4f4', // Light Gray
          colorText: '#333333', // Dark Gray
          //   colorBorder: '#d1d1d1', // Medium Gray
          colorSuccess: '#00bfa5', // Vibrant Green
          colorWarning: '#ffc107', // Bright Yellow
          //  colorError: '#ffebee', // Pastel Pink
        },
      }}
    >
      {children}
    </ConfigProvider>
  )
}
